import { render, staticRenderFns } from "./ImageAndExamsPhase.vue?vue&type=template&id=5332b553&scoped=true&"
import script from "./ImageAndExamsPhase.vue?vue&type=script&lang=js&"
export * from "./ImageAndExamsPhase.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndExamsPhase.vue?vue&type=style&index=0&id=5332b553&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332b553",
  null
  
)

export default component.exports